import React from 'react';
export var LocalizationContext = React.createContext({
    locale: 'en-US',
    translations: {},
});
//# sourceMappingURL=context.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ilenia/dist/context.js
// module id = 185
// module chunks = 0